import React, {useState} from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import FormularioWhat from "./FormularioWhat";
import Buscador from './Buscador';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function Opciones(props) {

    const{ itemCartWhap } = props;
    const [openNum, setOpenNum] = useState(false);

    const ClickOpenNum = () => {
        setOpenNum(true);
      };
      const CloseNum = () => {
        setOpenNum(false);
      };

      const [openBuscador, setOpenBuscador] = useState(false);

      const ClickOpenBuscador = () => {
        setOpenBuscador(true);
        };
        const CloseBuscador = () => {
        setOpenBuscador(false);
        };
    
  

    return (
        <Container>
             <Row>
                 <center>
        <button target="_blank"
          className="btn btn-primary"
          onClick={ClickOpenBuscador}
          >
            Buscar Consultora de Belleza
        </button> 
        <br />
        <br />
        <button target="_blank"
          className="btn btn-primary"
          onClick={ClickOpenNum}
          >
            Ya tengo Consultora de Belleza Enviar por Whatsapp
        </button> 
        </center>
            </Row>
        <Dialog
          open={openNum}
          onClose={CloseNum}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{"Enviar a Mi consultora de Belleza"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <FormularioWhat itemCartWhap={itemCartWhap} /> 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={CloseNum} color="danger">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openBuscador}
          onClose={CloseBuscador}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{"Enviar a Mi consultora de Belleza"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Buscador itemCartWhap={itemCartWhap} /> 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={CloseBuscador} color="danger">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
        </Container>
    )
}
